export enum FastLinksMenuConstants {
  setFastlinks = 'SET_FAST_LINKS_MENU',
  setSchools = 'SET_FAST_LINKS_MENU_SCHOOLS',
  open = 'OPEN_FAST_LINKS_MENU',
}
